import nightVideo from "@/assets/launch/night.mp4";
import nightMobileVideo from "@/assets/launch/night-mobile.mp4";
import nightImage from "@/assets/launch/night.jpg";
import crowd from "@/assets/launch/crowd.jpg";
import wordmark from "@/assets/launch/wordmark.png";
import mobile from "@/assets/launch/mobile.png";
import ticket from "@/assets/launch/ticket.png";
export default {
  nightVideo,
  nightMobileVideo,
  nightImage,
  crowd,
  wordmark,
  mobile,
  ticket,
};
